module.exports = __webpack_public_path__ + "img/item4-3m.7fe2d7b5.jpg";